module.exports = __webpack_public_path__ + "img/1740018420040-WhatsApp Image 2025-02-20 at 10.25.58 2.jpeg.47c06644.webp";